function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -3.04,
  x2: 29.49,
  y1: -2.41,
  y2: 28.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#253b80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#179bd7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28.87,
  height: 28.87,
  fill: "url(#a)",
  rx: 6.48,
  ry: 6.48
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.88 10.5l-.05.29c-.66 3.37-2.9 4.53-5.77 4.53H12.6a.71.71 0 0 0-.7.6l-.75 4.74-.21 1.34a.37.37 0 0 0 .37.43h2.59a.62.62 0 0 0 .62-.52v-.13l.48-3.09v-.17a.62.62 0 0 1 .62-.53h.39c2.51 0 4.47-1 5-4a3.38 3.38 0 0 0-.52-3 2.47 2.47 0 0 0-.61-.49z",
  "data-name": "<Path>",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.19 10.23l-.31-.08-.33-.06a8.1 8.1 0 0 0-1.28-.09h-3.9a.62.62 0 0 0-.61.53l-.83 5.25v.15a.71.71 0 0 1 .7-.6h1.46c2.87 0 5.11-1.16 5.77-4.53 0-.1 0-.2.05-.29a3.49 3.49 0 0 0-.54-.23z",
  "data-name": "<Path>",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.75 10.52a.62.62 0 0 1 .61-.53h3.9a8.1 8.1 0 0 1 1.29.09l.33.06.31.08h.15a3.54 3.54 0 0 1 .54.23 3.18 3.18 0 0 0-.67-2.86c-.74-.84-2.08-1.21-3.79-1.21h-5a.71.71 0 0 0-.7.6L7.66 20.17a.43.43 0 0 0 .42.49h3.07l.77-4.89z",
  "data-name": "<Path>"
})));

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.87 28.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.e100c61d.svg";
export { ForwardRef as ReactComponent };